import { isFbkApp } from './isFbkApp';
import { isPosty } from './isPosty';
import { isZigzag } from './isZigzag';

export function isApp() {
  return isZigzag() || isPosty() || isFbkApp();
}
